/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Pick any mass unit (g, mg, µg) and volume unit (mL, L, µL); conversions are handled internally and the result is shown in the unit you chose for the blank field.`)
};

const es_pctsol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Elige cualquier unidad de masa (g, mg, µg) y de volumen (mL, L, µL); las conversiones se gestionan internamente y el resultado se muestra en la unidad que elegiste para el campo en blanco.`)
};

const de_pctsol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Wählen Sie eine beliebige Masseneinheit (g, mg, µg) und Volumeneinheit (mL, L, µL); Umrechnungen erfolgen intern, und das Ergebnis wird in der für das leere Feld gewählten Einheit angezeigt.`)
};

const nl_pctsol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Kies een willekeurige massa-eenheid (g, mg, µg) en volume-eenheid (mL, L, µL); omrekeningen gebeuren intern en het resultaat wordt getoond in de eenheid die je voor het lege veld hebt gekozen.`)
};

const fr_pctsol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Choisissez n'importe quelle unité de masse (g, mg, µg) et de volume (mL, L, µL) ; les conversions sont gérées en interne et le résultat s'affiche dans l'unité choisie pour le champ vide.`)
};

const it_pctsol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Scegli qualsiasi unità di massa (g, mg, µg) e di volume (mL, L, µL); le conversioni vengono gestite internamente e il risultato viene mostrato nell'unità scelta per il campo vuoto.`)
};

const pt_br2_pctsol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Escolha qualquer unidade de massa (g, mg, µg) e de volume (mL, L, µL); as conversões são feitas internamente e o resultado é exibido na unidade escolhida para o campo em branco.`)
};

const pt_pctsol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Escolha qualquer unidade de massa (g, mg, µg) e de volume (mL, L, µL); as conversões são tratadas internamente e o resultado é apresentado na unidade escolhida para o campo em branco.`)
};

const ja_pctsol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。任意の質量単位 (g, mg, µg) と体積単位 (mL, L, µL) を選択できます。変換は内部で処理され、結果は空欄フィールドに選んだ単位で表示されます。`)
};

const zh_pctsol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。可任选质量单位（g、mg、µg）和体积单位（mL、L、µL）；内部会自动换算，结果以你为空白字段选择的单位显示。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_faq_a3", locale)
	if (locale === "en") return en_pctsol_faq_a3(inputs)
	if (locale === "es") return es_pctsol_faq_a3(inputs)
	if (locale === "de") return de_pctsol_faq_a3(inputs)
	if (locale === "nl") return nl_pctsol_faq_a3(inputs)
	if (locale === "fr") return fr_pctsol_faq_a3(inputs)
	if (locale === "it") return it_pctsol_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_faq_a3(inputs)
	if (locale === "pt") return pt_pctsol_faq_a3(inputs)
	if (locale === "ja") return ja_pctsol_faq_a3(inputs)
	return zh_pctsol_faq_a3(inputs)
};